export const ADMIN_STATUSES = [
  { key: "active", label: "Active" },
  { key: "invited", label: "Invited" },
  { key: "deactivated", label: "Deactivated" }
] as const;

export type AdminStatus = (typeof ADMIN_STATUSES)[number]["key"];

export const ADMIN_SORTS = [
  {
    key: "name_asc",
    label: "Name, A-Z"
  },
  {
    key: "name_desc",
    label: "Name, Z-A"
  },
  {
    key: "created_at_desc",
    label: "Invited At, Newest First"
  },
  {
    key: "created_at_asc",
    label: "Invited At, Oldest First"
  }
] as const;

export type AdminSort = (typeof ADMIN_SORTS)[number]["key"];
